import script from "./BaseIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseIcon.vue?vue&type=script&setup=true&lang=ts"

import "./BaseIcon.vue?vue&type=style&index=0&id=aa27e0d6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa27e0d6"]])

export default __exports__